import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import GoBack from "../../../GoBack";

const Div = styled.div`
  .arrow {
    font-weight: 500;
    font-size: 0.875rem;
  }
`;

function AddUserContainer() {
  return (
    <Div className="p-4 mx-auto max-w-[500px]">
      <div>
        <GoBack />
      </div>
      <Outlet />
    </Div>
  );
}

export default AddUserContainer;
